export default __webpack_public_path__ + "static/media/330_dummy2016-goldschmiede01-de.2b50ed1d.png";